import React from 'react';
import styled from 'styled-components';

import { OrganizationDetailsForm } from '../OrganizationDetailsForm/OrganizationDetailsForm';
import { H1 } from '../../../../../components/atoms';
import { IconButton } from '../../../../../components/molecules';
import { Modal } from '../../../../../components/molecules/Modal/Modal';
import { useOrganization } from '../../../../organization/hooks/useOrganization';
import { ReactComponent as Logo } from '../../../../../assets/images/logo.svg';

const StyledH1 = styled(H1)`
  margin-bottom: 15px;
  margin-top: 15px;
  margin-left: 20px;
`;

const HeaderWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding-right: 10px;
`;

const BodyWrapper = styled.div`
  display: flex;
  flex-direction: row;
  column-gap: 20px;
  padding: 20px 20px 0 20px;
`;

const CreateNewOrganizationModal = () => {
  const { onSubmit, handleCreateOrganization } = useOrganization();
  return (
    <Modal size='md' bodyStyle={{ padding: 10 }}>
      {(close) => (
        <>
          <HeaderWrapper>
            <StyledH1>Create new organization</StyledH1>
            <IconButton naked iconName='close' onClick={() => close()} />
          </HeaderWrapper>
          <BodyWrapper>
            <Logo width={96} height={96} style={{ flexShrink: 0 }} />
            <OrganizationDetailsForm
              onSubmit={onSubmit}
              handleSubmit={handleCreateOrganization}
              close={close}
            />
          </BodyWrapper>
        </>
      )}
    </Modal>
  );
};

export { CreateNewOrganizationModal };
